import { Wrapper } from './nav.styles';

import Menu from './menu';
import RegisterBanner from './register_banner';

export default function Nav() {
  return (
    <Wrapper>
      <RegisterBanner />
      <Menu />
    </Wrapper>
  );
}
